import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router'

interface ChatLinkProps {
  href: string
  label: string
}

export function ChatLink({ href, label }: ChatLinkProps) {
  return (
    <div className="max-w-m4 mt-2 ml-auto">
      <Link to={href} className="text-md text-cai-blue flex items-center gap-2 font-semibold hover:underline">
        {label}
        <ArrowRight />
      </Link>
    </div>
  )
}
